import React from "react";
import "./index.less";

const NoPermission: React.FC = () => {
  return (
    <div className="no-permission-page">
      <div className="no-permission-tip">您没有该页面的访问权限，如需访问，请与管理员联系。</div>
    </div>
  );
};

export default NoPermission;